import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { MarqueeBar } from "@/components/MarqueeBar";
import { About } from "@/components/About";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { Reviews } from "@/components/Reviews";
import { Blog } from "@/components/Blog";
import { BookingForm } from "@/components/BookingForm";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain bg-[#0A0A0A] text-white" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <MarqueeBar />
        <About />
        <Manifesto />
        <Services />
        <Reviews />
        <Blog />
        <BookingForm />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
